/* tslint:disable */

/**
 * Role of the delivery document:
 *   * WEIGHBRIDGE_TICKET
 *   * LOAD_REPORT
 *   * DAILY_LOG
 *   * OTHER
 */
type DeliveryDocumentRole =
  'WEIGHBRIDGE_TICKET' |
  'LOAD_REPORT' |
  'DAILY_LOG' |
  'OTHER';
namespace DeliveryDocumentRole {
  export const WEIGHBRIDGE_TICKET: DeliveryDocumentRole = 'WEIGHBRIDGE_TICKET';
  export const LOAD_REPORT: DeliveryDocumentRole = 'LOAD_REPORT';
  export const DAILY_LOG: DeliveryDocumentRole = 'DAILY_LOG';
  export const OTHER: DeliveryDocumentRole = 'OTHER';
  export function values(): DeliveryDocumentRole[] {
    return [
      WEIGHBRIDGE_TICKET,
      LOAD_REPORT,
      DAILY_LOG,
      OTHER
    ];
  }
}

export { DeliveryDocumentRole }